export class LoopService {
  private context: AudioContext;
  private mediaRecorder: MediaRecorder | null = null;
  private audioChunks: Blob[] = [];

  constructor() {
    this.context = new AudioContext();
  }

  async startRecording() {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.mediaRecorder = new MediaRecorder(stream);
    this.audioChunks = [];

    this.mediaRecorder.ondataavailable = (event) => {
      this.audioChunks.push(event.data);
    };

    this.mediaRecorder.start();
  }

  stopRecording(): Promise<AudioBuffer> {
    return new Promise((resolve) => {
      if (this.mediaRecorder) {
        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(this.audioChunks);
          const arrayBuffer = await audioBlob.arrayBuffer();
          const audioBuffer = await this.context.decodeAudioData(arrayBuffer);
          resolve(audioBuffer);
        };
        this.mediaRecorder.stop();
      }
    });
  }

  playLoop(audioBuffer: AudioBuffer) {
    const source = this.context.createBufferSource();
    source.buffer = audioBuffer;
    source.loop = true;
    source.connect(this.context.destination);
    source.start();
  }

  private static mediaRecorder: MediaRecorder | null = null;
  private static audioChunks: Blob[] = [];
  public static audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  private static source: AudioBufferSourceNode | null = null;

  public static async startRecording(): Promise<AudioBuffer> {
    return new Promise(async (resolve, reject) => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream, {
          mimeType: 'audio/webm;codecs=opus'
        });        LoopService.mediaRecorder = mediaRecorder;
        LoopService.audioChunks = [];

        mediaRecorder.ondataavailable = (event) => {
          LoopService.audioChunks.push(event.data);
        };

        mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(LoopService.audioChunks);
          const arrayBuffer = await audioBlob.arrayBuffer();
          const audioBuffer = await LoopService.audioContext.decodeAudioData(arrayBuffer);
          resolve(audioBuffer);
        };

        mediaRecorder.start();
      } catch (err) {
        console.error("Error starting recording:", err);
        reject(err);
      }
    });
  }

  public static stopRecording(): void {
    if (LoopService.mediaRecorder) {
      LoopService.mediaRecorder.stop();
      console.log("Recording stopped");
    }
  }

  public static startPlaying(audioBuffer: AudioBuffer): void {
    if (!LoopService.source) {
      const source = LoopService.audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.loop = true;
      source.connect(LoopService.audioContext.destination);

      source.start();
      LoopService.source = source;
      console.log("Loop is playing");
    }
  }

  public static stopPlaying(): void {
    if (LoopService.source) {
      LoopService.source.stop();
      LoopService.source.disconnect();
      LoopService.source = null;
      console.log("Loop stopped");
    }
  }
}
